<div class="header" *ngIf="useEmbededFilter && searchEnabled">
  <div fxLayout = "row wrap">
    <mat-form-field class="default-search-field" fxFlex>
      <input matInput (keyup.enter)="applyFilter()" placeholder="Search" [(ngModel)]="filters.str">
    </mat-form-field>
    <button mat-icon-button>
      <mat-icon matSuffix (click)="applyFilter()">search</mat-icon>
    </button>
    <button mat-icon-button (click)="clearFilter()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
</div>
<div class="relative-div" style="margin-top: 10px;">
  <!--
  <div [hidden]="!dataSource.isLoading"  style="position: absolute; margin-top: 65px; margin-left: auto; margin-right: auto; left: 0; right: 0; text-align: center; height: 100px; width: 100px">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
  -->
  <div *ngIf="dataSource && dataSource.isLoading" [hidden]="showOnlyPaginator">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <table mat-table #matTable [dataSource]="dataSource" matSort [hidden]="showOnlyPaginator">
    <ng-container *ngFor="let column of columns" [matColumnDef]="column.columnDef" [ngSwitch]="column.columnDef">
      <div *ngSwitchCase="'select'">
        <th mat-header-cell *matHeaderCellDef>
          <div class="selection">
            <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
                          [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
            <ng-container *ngIf="!selection.isEmpty()">
              <button mat-icon-button color="accent" (click)="deleteSelected()" *ngIf="canDelete()" title="Delete selected" >
                <mat-icon aria-label="Example icon-button with a heart icon">delete</mat-icon>
              </button>
              <button *ngFor="let customAction of multiselectCustomActions"
                      color="accent"
                      [title]="customAction.iconTitle"
                      mat-icon-button
                      [disabled] = "customAction.disabled(selection.selected)"
                      (click)="customAction.event(selection.selected)">
                <mat-icon *ngIf="!customAction.customIcon">{{customAction.icon}}</mat-icon>
                <ng-container *ngIf="customAction.customIcon">{{customAction.icon}}</ng-container>
              </button>
            </ng-container>

          </div>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)">
          </mat-checkbox>
        </td>
      </div>
      <div *ngSwitchCase="'actions'">
        <th mat-header-cell *matHeaderCellDef>{{ column.header }}</th>
        <td mat-cell *matCellDef="let row">
          <a *ngIf="canView()" mat-icon-button [routerLink]="viewLink(row)" [queryParams]="customQueryParams">
            <mat-icon aria-label="View">visibility</mat-icon>
          </a>
          <a *ngIf="canEdit()" [disabled]="!editLink(row)" mat-icon-button [routerLink]="editLink(row)">
            <mat-icon aria-label="Edit">edit</mat-icon>
          </a>
          <button *ngIf="canDelete()" mat-icon-button (click)="deleteRow(row)">
            <mat-icon aria-label="Delete">delete</mat-icon>
          </button>

          <button *ngFor="let customAction of singleCustomActions"
                  [disabled] = "customAction.disabled(row)"
                  [title]="customAction.iconTitle"
                  mat-icon-button
                  (click)="customAction.event(row)">
            <mat-icon *ngIf="!customAction.customIcon">{{customAction.icon}}</mat-icon>
            <ng-container *ngIf="customAction.customIcon">{{customAction.icon}}</ng-container>
          </button>
        </td>
      </div>

      <div *ngSwitchDefault>
        <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="column.sortable===false" >{{ column.header }}</th>
        <td mat-cell *matCellDef="let row" [ngClass]="rowClassCallback && rowClassCallback(row) || getClassesArray(column,row)">

          <span [ngStyle]="getCellStyle(column, row)">
            <ng-container *ngIf="column.icon && column.icon(row)"> <!-- icon needs to be a function -->
              <mat-icon style="vertical-align: middle">{{ column.icon(row) }}</mat-icon>
            </ng-container>

            <ng-container *ngIf="column.cellFlag && column.cellFlag(row)"> <!-- icon needs to be a function -->
              <flag-icon country="{{ column.cellFlag(row)?.toLowerCase() }}"></flag-icon>
            </ng-container>


            <ng-container *ngIf="column.link && column.link(row)">
              <ng-container *ngIf="column.isExternalLink && column.isExternalLink(row); else internalLink">
                <a [href]="column.link(row)">
                  {{ column.cell(row) }}
                </a>
              </ng-container>
              <ng-template #internalLink> <!-- internal link -->
                <a  [routerLink]="column.link(row)" [queryParams]="column.queryParams ? column.queryParams(row) : {}">
                {{ column.cell(row) }}
              </a>

              </ng-template>

            </ng-container>



            <ng-container *ngIf="!column.link && column.cell && column.cell(row)"> <!-- rest of the cell content -->
              {{ column.cell(row) }}
            </ng-container>

          </span>

        </td>
      </div>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="headers"></tr>
    <tr mat-row *matRowDef="let row; columns: headers;" (dblclick)="doubleClick(row)"></tr>
  </table>
  <mat-paginator #paginator [length]="dataSource?dataSource.length:0" [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true">
  </mat-paginator>
</div>
